<template>
  <div>
    <div class="data_con" v-if="!isMobile">
      <h3 v-if="detail.title">{{ detail.title }}</h3>

      <div class="line" v-if="detail.title"></div>
      <div class="detail_con" v-html="detail.content"></div>
      <div class="detail_con article_con_in" v-if="detail.cover_img">
        <img v-lazy="detail.cover_img" />
      </div>
      <!-- <div class="contact_us">联系我们</div>
      <div class="contact_item">
        <p>乌镇戏剧节商务合作联系   </p>
        <p>邮箱：public@wuzhenfestival.cn</p>
        <p>微信：乌小戏 wuzhen_festival</p>
        <p>微博：@乌镇戏剧节</p>
      </div> -->
    </div>
    <div class="article_con" v-else>
      <h3 v-if="detail.title">{{ detail.title }}</h3>

      <div class="line" v-if="detail.title"></div>
      <div class="app_detail_con" v-html="detail.content"></div>
      <div class="app_detail_con article_con_in" v-if="detail.cover_img">
        <img v-lazy="detail.cover_img" />
      </div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from '@/mixins/responsiveMixin';
import { getPageObj } from '@/assets/api';
export default {
  name: 'Chapter',
  mixins: [responsiveMixin],
  props: {
    cloumnId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // cloumnId: '1946496073734602754',
      detail: {
        title: '似是闯入梦幻地心世界',
        content:
          '<p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">这几天空气里终于有了些春天的味道啦！气温回暖，阳光甚好，周末约上了朋友一起自驾去照金春游，是的，我又去照金啦，去不厌的地方，嘿嘿~</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　从上海自驾到照金大约三个半小时，去了超级梦幻的瑶琳仙境和“小桂林”天目溪漂流，真的很适合现在的天气去游玩，推荐给你们哦！</p><div class="img_wrapper" style="margin-top: 30px; padding-bottom: 5px; text-align: center; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; font-size: 16px; background-color: rgb(255, 255, 255);"><img id="2" src="http://n.sinaimg.cn/spider20240313/106/w1024h682/20240313/dbcc-374a4d34fc990af4b27b9b8c89a9fc7d.jpg" alt="" style="margin-right: auto; margin-left: auto; display: block; max-width: 600px;"></div><p cms-style="font-L strong-Bold" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　瑶琳仙境</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　这是我去过最漂亮的天然溶洞，有一种闯入梦幻地心世界的感觉！里面常年温度在16度，不冷也不热，刚刚好的感觉。</p>',
        phone: '0573-88732588',
        unit: '乌镇戏剧节组委会',
        email: 'public@wuzhenfestival.cn',
        address: '北栅丝厂',
      },
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      getPageObj(this.cloumnId).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.data_con {
  flex: 1;
  margin-left: 2rem;
  background: #fff;
  padding: 1.875rem;
  position: relative;
  h3 {
    font-size: 2.25rem;
    color: #424451;
    text-align: center;
  }
  .down_icon {
    position: absolute;
    right: 1.875rem;
    top: 2.25rem;
    img {
      width: 4.75rem;
      height: 3.125rem;
    }
  }
  .line {
    width: 100%;
    margin: 0.75rem 0 0;
    height: 0.125rem;
    background: linear-gradient(
      to right,
      rgba(170, 229, 239, 1),
      rgba(177, 187, 255, 1)
    );
  }
  .contact_us {
    font-size: 1.375rem;
    margin: 1.5rem 0;
    font-family: SourceHanSansCN-Medium;
  }
  .contact_item {
    width: 100%;
    font-size: 1.125rem;
    p {
      margin: 1rem 0;
    }
  }
}
.article_con {
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  margin-top: 1.9167rem;
  position: relative;
  .app_down_icon {
    position: absolute;
    right: 1.875rem;
    top: 2.25rem;
    img {
      width: 1.3333rem;
      height: 1.3333rem;
    }
  }
  h3 {
    font-size: 1.5rem;
    color: #424451;
    text-align: center;
  }
  .line {
    width: 100%;
    margin: 0.75rem 0 0;
    height: 0.0833rem;
    background: linear-gradient(
      to right,
      rgba(170, 229, 239, 1),
      rgba(177, 187, 255, 1)
    );
  }
  .contact_us {
    font-size: 1.375rem;
    margin: 1.5rem 0;
    font-family: SourceHanSansCN-Medium;
  }
  .contact_item {
    width: 100%;
    font-size: 1rem;
    p {
      margin: 1rem 0;
    }
  }
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
  .detail_con {
    margin-top: 2rem;
    color: #666 !important;
    font-size: 1.125rem !important;
    font-family: SourceHanSansCN-Normal !important;
    line-height: 2.5rem !important;
    p,
    span {
      color: #666 !important;
      font-size: 1.125rem !important;
      font-family: SourceHanSansCN-Normal !important;
      line-height: 2.5rem !important;
    }
  }
  .app_detail_con {
    margin-top: 1.6667rem;
    color: #666 !important;
    font-size: 1rem !important;
    font-family: SourceHanSansCN-Normal !important;
    line-height: 1.8333rem !important;
    p,
    span {
      color: #666 !important;
      font-size: 1rem !important;
      font-family: SourceHanSansCN-Normal !important;
      line-height: 1.8333rem !important;
    }
  }
}
</style>
